import { render, staticRenderFns } from "./chooseBusinessPrice.vue?vue&type=template&id=73c8d1a8&scoped=true"
import script from "./chooseBusinessPrice.vue?vue&type=script&lang=js"
export * from "./chooseBusinessPrice.vue?vue&type=script&lang=js"
import style0 from "./chooseBusinessPrice.vue?vue&type=style&index=0&id=73c8d1a8&prod&lang=scss"
import style1 from "./chooseBusinessPrice.vue?vue&type=style&index=1&id=73c8d1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c8d1a8",
  null
  
)

export default component.exports